module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-delete"
  }, [_c('div', {
    staticClass: "move",
    style: (_vm.txtStyle),
    on: {
      "touchstart": _vm._touchStart,
      "touchmove": _vm._touchMove,
      "touchend": _vm._touchEnd
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "deleteIcon",
    style: (_vm.zIndex),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteItem(_vm.index)
      }
    }
  }, [_c('span', [_vm._v("删除")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12fae7e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/touchDelete/touchDelete.vue
// module id = 376
// module chunks = 68